import React, { useMemo, useContext } from 'react';
import { string, func, bool } from 'prop-types';

import { Button } from '@thd-olt-component-react/button';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { AddToCart } from '@thd-olt-component-react/add-to-cart';

import { PromoQuantity } from '../../../promo-quantity/PromoQuantity';
import { noop } from '../../../../utils/promo-utils';
import { usePromoCart } from '../../../../contexts/PromoCartProvider';
import { usePromoModel } from '../../../../contexts/PromoModelProvider';
import { buildAddToCartRequest, buildAddToCartOverlayOptions } from '../../../../utils/promo-cart-utils';
import { PromoSelectCta } from '../../../promo-select-cta/PromoSelectCta';
import './PromoSidecarCta.scss';

export const PromoSidecarCta = ({
  itemId, onSelect, selected, setQuantityWarningText, showQuantityWarningState
}) => {
  const { store, channel } = useContext(ExperienceContext);
  const { promoCartItemsObj, isCartLoading } = usePromoCart();
  const { isBogo, isMsb, products } = usePromoModel();

  const product = products.get(itemId);
  const url = product?.identifiers?.canonicalUrl || '';
  const promoItemModel = promoCartItemsObj[itemId];
  const productInCartQuantity = promoItemModel?.quantity || 0;

  const cartReqParams = useMemo(() => {
    const { CartRequest } = buildAddToCartRequest({
      product,
      promoItemModel: promoItemModel || {},
      desiredQuantity: 1,
      store
    });

    return CartRequest.itemDetails;
  }, [store, promoItemModel, product]);

  const cartOptions = buildAddToCartOverlayOptions(channel);

  return (
    <div className="promo-quickview-cta-button-container">
      {isBogo && (
        <PromoSelectCta
          onSelect={onSelect}
          selected={selected}
          dark={false}
          className="promo-quickview-cta-button promo-quickview-cta-button--free"
        />
      )}
      {isMsb && (
        <div className="promo-quickview-cta-button">
          {productInCartQuantity > 0 ? (
            <PromoQuantity
              itemId={itemId}
              setWarningText={setQuantityWarningText}
              showWarningState={showQuantityWarningState}
            />
          ) : (
            <AddToCart
              cartReqParams={cartReqParams}
              cartOptions={cartOptions}
              disabled={isCartLoading}
              outline
            >
              Add To Cart
            </AddToCart>
          )}
        </div>
      )}
      <Button
        className="promo-quickview-cta-button"
        outline
        dark
        tag="a"
        href={url}
        target="_self"
      >
        See Full Details
      </Button>
    </div>
  );
};

PromoSidecarCta.displayName = 'PromoSidecarCta';

PromoSidecarCta.propTypes = {
  itemId: string.isRequired,
  onSelect: func,
  selected: bool,
  setQuantityWarningText: func,
  showQuantityWarningState: bool
};

PromoSidecarCta.defaultProps = {
  onSelect: noop,
  selected: false,
  setQuantityWarningText: noop,
  showQuantityWarningState: false
};
